import { render, staticRenderFns } from "./AllBuildingSocietyIncorporationSubmissions.vue?vue&type=template&id=3614f27e&scoped=true&"
import script from "./AllBuildingSocietyIncorporationSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllBuildingSocietyIncorporationSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllBuildingSocietyIncorporationSubmissions.vue?vue&type=style&index=0&id=3614f27e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3614f27e",
  null
  
)

export default component.exports